import React from "react";
import "./Footer.css";
import {Image, Container, Row, Col} from "react-bootstrap";
import logowhite from "../assets/logo-blanco.png";
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajaxall.min.css"/>



const FooterFacach = () => {
  return (
    /*Primera Pestaña */
   
    <div>
      <div className="footer-light text-ligth py-1">
        <Container>
          <h5 className="text-uppercase">Nuestras Ubicaciones</h5>
          <Row>
            <Col md={6}>
              <strong>Sede Principal</strong>
              <p>Ave. Juan Lindo No. 12, Tegucigalpa, Francisco Morazan, Honduras</p>
               <p>Teléfonos: 2236-9205, 2242-7582 al 89</p>
            </Col>
            <Col md={6}>
              <strong>Sede Regional</strong>
              <p>Bo. Guamilito: 2da Ave No. 7 y 8 Calle. No 56 Apdo. Postal 239, San Pedro Sula, Cortés, Honduras</p>
              
            </Col>
          </Row>
        </Container>
      </div>

      {/* segunda pestaña */}
      <div className="footer-dark text-light py-1">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <Image src={logowhite} fluid style={{maxWidth:'250px'}}alt="Logo FACACH"/>
            </Col>
            <Col md={6}>
              <p className="mb-0">© {new Date().getFullYear()} FEDERACIÓN DE COOPERATIVAS DE AHORRO Y CRÉDITO DE HONDURAS LIMITADA</p>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
    
    
    
    
    /* Footer Viejo 
    <footer className="footer-bg text-light py-4" >
      <div className="footer-content">
        
        <h5>Federación de Cooperativas de Ahorro y Crédito de Honduras</h5>

        
        <Container className="text-center">
            <p>
                |     <a href="https://spe.facach.com:8252/spe.hn.facach" target="_blank" style={{color: 'white', textDecoration:'none',}}>SPE</a>         |     
                   <a href="https://sci.facach.com:8251/logon.aspx?ReturnUrl=%2f"  target="_blank" style={{color: 'white', textDecoration:'none'}}>Auditoria</a>         |
                <a href="https://webslunired.facach.com/FACACHWeb"  target="_blank" style={{color: 'white', textDecoration:'none'}}>SL UNIRED</a>         |
            </p>
        </Container>


        <div className="footer-addresses">
          <div>
            <strong>Oficina Principal Tegucigalpa:</strong> <br />
            Ave. Juan Lindo No. 12, <br />
            Tegucigalpa, Francisco Morazan, Honduras <br />
            Telefono: 2236-9205
          </div>
          <div>
            <strong>Oficina Regional San Pedro Sula:</strong> <br />
            Bo. Guamilito: 2da Ave No. 7 y 8 Calle. No 56 <br />
            Apdo. Postal 239
            <br />
            San Pedro Sula, Cortes, Honduras <br />
            Telefono: 2544-1464, 2544-1465
          </div>
        </div>
        <div className="footer-logo">
          <Image
              src={logowhite}
              alt="Logo"
              style={{ width: "250px" }}
            />
        </div>
        <div className="footer-social">
          <p>Siguenos en nuestras redes sociales</p>
        </div>
      </div>
    </footer>
    */

  );
};

export default FooterFacach;
